export default __webpack_public_path__ + "static/media/check_white.299c8148.svg";